import React from 'react';
import logoImage from '../../images/logo.png';
import logoMiniImage from '../../images/logo-mini.png';
import '../../css/Header.css';

const Logo: React.FC = () => {
  return (
    <div className="logo-container" aria-label="Dental Puente Ortodoncia">
      <img className="logo-full" src={logoImage} alt="Dental Puente Ortodoncia" />
      <img className="logo-mini" src={logoMiniImage} alt="Dental Puente" />
    </div>
  );
};

export default Logo;
